import { Card } from '@yleisradio/areena-types';
import { CardWithPointer, LoggedInSubAccount } from './types';

export function isSubAccount(obj: any): obj is LoggedInSubAccount {
  return Boolean(obj) && 'isSubAccount' in obj && Boolean(obj.isSubAccount);
}

export function isCardWithPointer(
  card: Card | undefined
): card is CardWithPointer {
  return card?.pointer !== undefined;
}
